import { AuthPage } from './pages/AuthPage.tsx';
import { StatusPage } from './pages/StatusPage.tsx';
import { isDeckPath } from './lib/deck-route.ts';
import { NotFoundPage } from './pages/NotFoundPage.tsx';

export function App() {
  const path = window.location.pathname;
  if (path === '/status') return <StatusPage />;
  if (path !== '/' && path !== '/pdf' && !isDeckPath(path))
    return <NotFoundPage />;
  return <AuthPage />;
}
